import _regeneratorRuntime from "@babel/runtime/regenerator";
var _excluded = ["children", "question", "onResolve", "onSubmit"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { createContext, useEffect, useState } from 'react';
import { useOrg } from '../hooks/useOrg';
import { useUser } from '../hooks/useUser';
import { doDelete, patch, post } from '../lib/api';
export var Context = createContext({});
export var Provider = function Provider(_ref) {
  var _firstReply$profile;

  var children = _ref.children,
      question = _ref.question,
      onResolve = _ref.onResolve,
      onSubmit = _ref.onSubmit,
      other = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useOrg = useOrg(),
      organizationId = _useOrg.organizationId,
      apiHost = _useOrg.apiHost;

  var _useUser = useUser(),
      user = _useUser.user;

  var _useState = useState([]),
      replies = _useState[0],
      setReplies = _useState[1];

  var _useState2 = useState(question === null || question === void 0 ? void 0 : question.resolved_reply_id),
      resolvedBy = _useState2[0],
      setResolvedBy = _useState2[1];

  var _useState3 = useState(question === null || question === void 0 ? void 0 : question.resolved),
      resolved = _useState3[0],
      setResolved = _useState3[1];

  var firstReply = replies[0];
  var questionAuthorId = (firstReply === null || firstReply === void 0 ? void 0 : (_firstReply$profile = firstReply.profile) === null || _firstReply$profile === void 0 ? void 0 : _firstReply$profile.id) || null;

  var handleResolve = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolved, replyId) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (replyId === void 0) {
                replyId = null;
              }

              _context.next = 3;
              return post(apiHost, '/api/question/resolve', {
                messageId: question === null || question === void 0 ? void 0 : question.id,
                replyId: replyId,
                organizationId: organizationId,
                resolved: resolved
              });

            case 3:
              setResolved(resolved);
              setResolvedBy(replyId);

              if (onResolve) {
                onResolve(resolved, replyId);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleResolve(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleReplyDelete = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return doDelete(apiHost, "/api/replies/" + id, {
                organizationId: organizationId
              });

            case 2:
              setReplies(replies.filter(function (reply) {
                return id !== reply.id;
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleReplyDelete(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handlePublish = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, published) {
      var newReplies;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return patch(apiHost, "/api/replies/" + id, {
                organizationId: organizationId,
                published: published
              });

            case 2:
              newReplies = [].concat(replies);
              newReplies.some(function (reply) {
                if (reply.id === id) {
                  reply.published = published;
                  return true;
                }
              });
              setReplies(newReplies);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handlePublish(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  useEffect(function () {
    setReplies(other.replies.filter(function (reply) {
      return reply.published || !reply.published && (user === null || user === void 0 ? void 0 : user.isModerator);
    }));
  }, [other.replies, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    setResolved(question.resolved);
  }, [question.resolved]);
  useEffect(function () {
    setResolvedBy(question.resolved_reply_id);
  }, [question.resolved_reply_id]);
  var value = {
    replies: replies,
    resolvedBy: resolvedBy,
    resolved: resolved,
    questionAuthorId: questionAuthorId,
    question: question,
    onSubmit: onSubmit,
    handleResolve: handleResolve,
    handleReplyDelete: handleReplyDelete,
    handlePublish: handlePublish
  };
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, children);
};